import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { WbButton, WbDivider } from '@agilelab/plugin-wb-platform';
import { Box, useTheme } from '@material-ui/core';
import { FC, useState } from 'react';
import { LogFileButton } from '../../LogFileButton';
import { Deploy } from '../../types';
import { TerminateDialog } from './TerminateDialog';

interface Props {
  deploy: Deploy;
  canProvision: boolean;
}

export const LatestProvisioningActions: FC<Props> = ({
  deploy,
  canProvision,
}) => {
  const theme = useTheme();

  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="end"
        style={{ gap: 16 }}
      >
        {deploy.status === DagStatus.RUNNING && canProvision && (
          <>
            <WbButton
              color="primary"
              variant="contained"
              label="Terminate"
              onClick={() => setOpenDialog(true)}
              style={{
                backgroundColor: theme.palette.error.main,
              }}
            />
            <WbDivider />
          </>
        )}

        <LogFileButton deploy={deploy} />
      </Box>
      <TerminateDialog open={openDialog} onClose={() => setOpenDialog(false)} />
    </>
  );
};
